//export const SERVER_URL = "http://localhost:5001";
export const SERVER_URL = "https://quickapplybackend.cmxph.com";
